export default "__VITE_ASSET__72b14d43__"